<div class="modal-header">
  <h5 class="modal-title">
    <i class="fa fa-folder-open me-2"></i>Управление на папки
  </h5>
  <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <!-- Error message -->
  <div *ngIf="errorMessage" class="alert alert-danger mb-3" role="alert">
    <i class="fa fa-exclamation-circle me-2"></i>{{errorMessage}}
  </div>

  <!-- Create new folder section -->
  <div class="create-folder-section mb-4">
    <label class="form-label"><strong>Нова папка</strong></label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Име на папката"
        [(ngModel)]="newFolderName"
        [disabled]="isSaving"
        (keyup.enter)="createFolder()">
      <button
        type="button"
        class="btn btn-primary"
        (click)="createFolder()"
        [disabled]="isSaving || !newFolderName.trim()">
        <i *ngIf="!isSaving" class="fa fa-plus me-1"></i>
        <i *ngIf="isSaving" class="fa fa-spinner fa-spin me-1"></i>
        Създай
      </button>
    </div>
  </div>

  <!-- Folder list section -->
  <div class="folder-list-section">
    <label class="form-label"><strong>Съществуващи папки</strong></label>

    <!-- Loading state -->
    <div *ngIf="isLoading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Зареждане...</span>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && folders.length === 0" class="text-center py-4 text-muted">
      <i class="fa fa-folder-open-o fa-2x mb-2"></i>
      <p>Няма създадени папки</p>
    </div>

    <!-- Folder list -->
    <div *ngIf="!isLoading && folders.length > 0" class="folder-list">
      <div *ngFor="let folder of folders" class="folder-item">
        <!-- View mode -->
        <ng-container *ngIf="editingFolderId !== folder.idMailFolder">
          <div class="folder-info">
            <i class="fa fa-folder me-2"></i>
            <span class="folder-name">{{folder.name}}</span>
            <span class="badge bg-secondary ms-2">{{folder.messageCount}}</span>
          </div>
          <div class="folder-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary me-1"
              (click)="startEdit(folder)"
              [disabled]="isSaving"
              title="Редактирай">
              <i class="fa fa-pencil"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="deleteFolder(folder)"
              [disabled]="isSaving || folder.messageCount > 0"
              [title]="folder.messageCount > 0 ? 'Папката не е празна' : 'Изтрий'">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </ng-container>

        <!-- Edit mode -->
        <ng-container *ngIf="editingFolderId === folder.idMailFolder">
          <div class="folder-edit">
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="editingFolderName"
              [disabled]="isSaving"
              (keyup.enter)="saveEdit()"
              (keyup.escape)="cancelEdit()">
          </div>
          <div class="folder-actions">
            <button
              type="button"
              class="btn btn-sm btn-success me-1"
              (click)="saveEdit()"
              [disabled]="isSaving || !editingFolderName.trim()"
              title="Запази">
              <i *ngIf="!isSaving" class="fa fa-check"></i>
              <i *ngIf="isSaving" class="fa fa-spinner fa-spin"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              (click)="cancelEdit()"
              [disabled]="isSaving"
              title="Отказ">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Info message -->
  <div class="alert alert-info mt-3" role="alert">
    <i class="fa fa-info-circle me-2"></i>
    Папките с съобщения не могат да бъдат изтрити.
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="close()"
    [disabled]="isSaving">
    <i class="fa fa-times me-2"></i>Затвори
  </button>
</div>
